import { useState, useEffect } from 'react';

export function useTheme() {
  const [theme, setTheme] = useState('dark'); // Темная тема по умолчанию

  useEffect(() => {
    // Проверяем сохраненную тему или используем темную по умолчанию
    const savedTheme = localStorage.getItem('theme') || 'dark';
    setTheme(savedTheme);
    document.documentElement.classList.toggle('dark', savedTheme === 'dark');
  }, []);

  const toggleTheme = () => {
    const newTheme = theme === 'dark' ? 'light' : 'dark';
    setTheme(newTheme);
    localStorage.setItem('theme', newTheme);
    document.documentElement.classList.toggle('dark', newTheme === 'dark');
  };

  return { theme, toggleTheme };
}